import { combineReducers } from 'redux';
import {
  ACTION_LOAD_CREATE_PREPARATION__SUCCESS,
  ACTION_CREATE_SITE__FAIL,
  ACTION_CREATE_SITE__SUCCESS,
  ACTION_CREATE_SITE__REQUEST,
  ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS,
} from '../actionTypes';

import errors from './errors';

const createPreparation = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CREATE_PREPARATION__SUCCESS:
      return action.payload.createPreparation;

    default:
      return state;
  }
};

const lastCreatedSiteId = (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE__REQUEST:
    case ACTION_CREATE_SITE__FAIL:
      return null;

    case ACTION_CREATE_SITE__SUCCESS:
      return action.payload.site.id;

    default:
      return state;
  }
};

const allPromotedSiteToWlTemplateToLangs = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS:
      return action.payload.promotedSiteToWlTemplateToLangs;

    default:
      return state;
  }
};

export default combineReducers({
  allPromotedSiteToWlTemplateToLangs,
  createPreparation,
  lastCreatedSiteId,
  errors,
});
